module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjA1MDQgMFYxMkg1LjQyMDE3VjBINi42MDUwNFpNMTIgNS4zNzc1OVY2LjUyMjgySDBWNS4zNzc1OUgxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 1bhZ
// module chunks = 7